import { Controller } from "@hotwired/stimulus";

/**
 * Starts stopwatch that counts time forward from "startTime" to "endTime", updated every second
 *
 * Usage:
 *   1. Define "startTime" and "endTime" values for controller;
 *   2. Define "updateView" - value is responsible for refreshing page;
 *   3. Optional: Use "stopwatch_time" helper for initial display.
 *
 * Example:
 *   <span
 *     data-controller="stopwatch"
 *     data-stopwatch-start-time-value="<%= (order_service.duration * 60).to_i %>"
 *     data-stopwatch-end-time-value="<%= (order_service.total_target_time * 60).to_i %>"
 *     data-stopwatch-update-view-value="<%= !order_service.target_time_failed? %>">
 *     <%= stopwatch_time(order_service.duration) %>
 *   </span>
 */

// Connects to data-controller="stopwatch"
export default class extends Controller {
  static values = {
    startTime: Number,
    endTime: Number,
    updateView: Boolean,
  };

  connect() {
    this.ticker = setInterval(this.#tick.bind(this), 1000);
  }

  disconnect() {
    clearInterval(this.ticker);
  }

  #tick() {
    this.startTimeValue = this.startTimeValue + 1;
    if (this.#isStopTicker) Turbo.visit(window.location.pathname);
    else this.element.innerHTML = this.#prettyTime();
  }

  get #isStopTicker() {
    return this.startTimeValue > this.endTimeValue && this.updateViewValue;
  }

  #prettyTime() {
    const minutes = Math.floor(this.startTimeValue / 60);
    const seconds = this.startTimeValue % 60;

    return (
      minutes.toString().padStart(2, "0") +
      ":" +
      seconds.toString().padStart(2, "0")
    );
  }
}
